exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card.item[data-v-46af916c]{margin-bottom:20px;border:1px solid #dfe0e2;box-shadow:none}.item .card-content[data-v-46af916c]{padding:1rem}.item+.item[data-v-46af916c]{border-top:1px solid #ccc}.center[data-v-46af916c]{margin:auto;width:60%;padding:10px;text-align:center}ul.grid-mode[data-v-46af916c]{display:grid;grid-gap:0 30px;grid-auto-flow:row dense;grid-template-columns:1fr [col] 1fr [col] 1fr [col]}ul.list-mode[data-v-46af916c]{display:flex;flex-direction:column}@media screen and (max-width:1420px){ul.grid-mode[data-v-46af916c]{grid-template-columns:1fr [col] 1fr [col]}}", ""]);

// exports
